import {TagsResultsService} from './tagsResults.service';
import { Component, Inject, Input, OnInit} from 'ng-metadata/core';
import {TagItem, TagsService} from '../tags.service';
import {STATE_NAMES} from '../../primoExplore/primoExploreStates.module';
import {getVid} from '../../appConfig/appConfigForward';
import {ConfigurationUtil} from "../../nddUtils/configurationUtil.service";

@Component({
    selector: 'prm-tags-results',
    templateUrl: 'components/tags/tagsResults/tags-results.html',
})

export class PrmTagsResults {
    public tagsResultsLimit: number = 1000;
    constructor(private tagsResultsService: TagsResultsService,
                private tagsService: TagsService,
                @Inject('$state') private $state: ng.ui.IStateService,
                private configurationUtil: ConfigurationUtil) {
    }

    get tagsSearchResult(){
        return this.tagsService.tagsSearchResult;
    }
    get searchInProgress(){
        return this.tagsService.searchInProgress;
    }

    /*
    returns the advanced search url of tagName
    */
    public resultSearchUrl(tagName){
        let query = "usertag,contains,"+tagName+",AND";
        if(this.configurationUtil.isSuprima()){
            query = "user_tags,exact,"+tagName+",AND";
        }
        let params = {mode:'advanced',query:query,vid:getVid()};
        return this.$state.href(STATE_NAMES.SEARCH, params);
    }

}


// WEBPACK FOOTER //
// ./src/main/webapp/components/tags/tagsResults/tagsResults.directive.ts